import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import  {BonsusLayer}  from '../components/manage_bonus/BonsusLayer'

export const BonsusPage = () => {
  return (
    <MasterLayout>
        <BonsusLayer/>
    </MasterLayout>
  )
}
